module.exports = __webpack_public_path__ + "static/media/trip_home.fb2d4453.svg";